import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const LazyAssignRolesPage: LoadableType<Omit<unknown, 'flags'>> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-AssignRolesPage" */ '../src/PermissionsTransition/assign-roles/AssignRolesPage.tsx'
			)
		).AssignRolesPage,
});
